import { object, string } from '@calendly/form/validation'
import { httpRequest } from '@calendly/http-tools'
import { I18n } from '@calendly/i18n'

export const validationSchema = ({ owner: { type, id } }) => object({
  slug: string().test('validateSlug', '', async (slug, { createError }) => {
    const [success, response] = await httpRequest({
      url: '/api/validators/slug',
      method: 'POST',
      data: {
        slug,
        owner_id: id,
        owner_type: type
      }
    })

    if (success) {
      return true
    }

    if (response.type === 'validation') {
      return createError(response.payload)
    }

    return createError({
      message: I18n.t('publisher.slug_validator.failure')
    })
  })
})
